/* constants here should likely be migrated into serverless config call but are here until such changes are made */

export const cartMax = 5;

export const blockedStatuses = [
  'restricted',
  'suspended',
  'grace period',
];

export const allowedStatuses = [
  200,
  409,
  423,
];

// For  Hot deals - analytics event
export const homePageCartEvent = 'Cart from home';

export const hotDealsPageCartEvent = 'Cart from hot deals';

export const hotDealsSliderCartEvent = 'Cart from hot deals slider';

export const invalidDealsCartEvent = 'Invalid hot deals slider';

export const home = 'Home page';

export const hotDealsPage = 'Hot deals page';

export const homePageSliderCartEvent = 'Cart from home slider';

// Function to display decimal values only if they are non-zero
export const formatCurrency = amount => {
  const num = Number(amount ?? 0);
  return Number.isInteger(num) ? num.toString() : num.toFixed(2);
};
